import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormattedConvenienceVariables } from 'components/ConvenienceVariables';
import { RootState } from 'lib/store';

const initialState: FormattedConvenienceVariables = {
  partnerName: 'Lig',
  partnerPhone: '(833) 748-5302',
};

const convenienceVariablesSlice = createSlice({
  initialState: initialState,
  name: 'convenienceVariables',
  reducers: {
    setConvenienceVariables: (
      _state,
      action: PayloadAction<FormattedConvenienceVariables>
    ) => {
      return action.payload;
    },
  },
});

const { reducer } = convenienceVariablesSlice;

export const selectPartnerName = (state: RootState) =>
  state.convenienceVariables.partnerName;

export const selectPartnerPhone = (state: RootState) =>
  state.convenienceVariables.partnerPhone;

export default reducer;
